import React from "react";
import { Form, Modal } from "antd";
import { CloseOutlined } from '@ant-design/icons';
import { Box, Heading, Paragraph } from "theme-ui";
import { FormSelect } from "components/common/forms";
import styled from "@emotion/styled";

type Props = {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
}
export const ShareModal: React.FC<Props> = ({ isOpen, setIsOpen }) => {
  const [form] = Form.useForm();

  const onCancel = () => {
    setIsOpen(false);
  };

  const onSend = () => {
    setIsOpen(false);
    form.resetFields();
  };

  const buttonProps = {
    cancelText: "Cancel",
    okText: "Send",
    onCancel: onCancel,
    onOk: onSend,
    cancelButtonProps: { className: 'ant-btn-text' },
  };

  const closeIcon = <Circle><CloseOutlined /></Circle>;

  return (
    <Modal visible={isOpen} title="" {...buttonProps} closeIcon={closeIcon} getContainer={document.body}>
      <Heading>Share reservation</Heading>
      <Paragraph>Please enter your email for us to send your receipt</Paragraph>
      <Box my={5}>
        <Form form={form} layout="vertical">
          <FormSelect name="emails" label="Email Address" type="tags"
            help="(Use commas to enter multiple emails)"
          />
        </Form>
      </Box>
    </Modal>
  );
};

const Circle = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '20px auto 0',
  marginRight: 20,
  width: 25,
  height: 25,
  borderRadius: 100,
  background: '#546D49',
  color: '#fff',
});
